import React, { Fragment } from 'react';
import { CreditCard, BarChart3, ShieldAlert, RefreshCcw, Globe, Zap } from 'lucide-react';
export function Features() {
  const features = [{
    icon: <CreditCard className="w-6 h-6 text-blue-600" data-id="element-25" />,
    title: 'Metered Billing',
    description: 'Auto-creates Stripe/Polar billing meters. Syncs usage in real-time (not batch). Handles webhook retries and idempotency.'
  }, {
    icon: <BarChart3 className="w-6 h-6 text-blue-600" data-id="element-26" />,
    title: 'Cost Attribution',
    description: 'Automatically track usage by userID or tenantID. We attribute every token to the right customer and sync it to the billing provider of your choice in real-time.',
    scheme: [{
      label: 'Request',
      sub: 'userID/tenantID'
    }, {
      label: 'TokenGates',
      sub: 'Cost Calculation'
    }, {
      label: 'Billing',
      sub: 'Meter Sync'
    }]
  }, {
    icon: <Globe className="w-6 h-6 text-blue-600" data-id="element-27" />,
    title: 'Low Latency LLM Gateway',
    description: 'Planet-scale performance across 5 continents and 26 PoP locations. Globally distributed infrastructure with <50ms latency.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-blue-600" data-id="element-28" />,
    title: 'Rate Limiting & Enforcement',
    description: 'Advanced rate-limiting and overage enforcement. Real-time balance info tracking to prevent surprise costs and abuse.'
  }, {
    icon: <RefreshCcw className="w-6 h-6 text-blue-600" data-id="element-29" />,
    title: 'Error Handling',
    description: 'Webhook failures? We retry automatically. Billing provider down? We queue events. Rate limits? We handle backoff.'
  }, {
    icon: <Zap className="w-6 h-6 text-blue-600" data-id="element-30" />,
    title: 'Custom Margins',
    description: 'Set your markup (30%, 50%, whatever) and keep 100% of the profit. We never markup your LLM costs.'
  }];
  return <section id="features" className="py-24 bg-gray-50" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="text-center mb-16" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-34">
            Zero Backend Code. Zero Ops Work.
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-35">
            Everything you need to monetize your AI product, handled
            automatically.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-36">
          {features.map((feature, i) => <div key={i} className="bg-white p-8 rounded-2xl border border-gray-200 hover:border-blue-300 transition-colors group flex flex-col" data-id="element-37">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-38">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-39">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-grow" data-id="element-40">
                {feature.description}
              </p>
              {feature.scheme && <div className="mt-auto pt-6 border-t border-gray-100" data-id="element-41">
                  <div className="flex items-center justify-between gap-2" data-id="element-42">
                    {feature.scheme.map((step, idx) => <Fragment key={idx} data-id="element-43">
                        <div className="text-center" data-id="element-44">
                          <div className="text-[10px] font-bold text-blue-600 uppercase tracking-tighter mb-1" data-id="element-45">
                            {step.label}
                          </div>
                          <div className="text-[9px] text-gray-400 leading-none" data-id="element-46">
                            {step.sub}
                          </div>
                        </div>
                        {idx < feature.scheme.length - 1 && <div className="h-px bg-gray-100 flex-grow" data-id="element-47" />}
                      </Fragment>)}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}